var paymentOverlay ='<div id="stripeoverlay" style="position: fixed; filter: alpha(opacity=80); top: 0px; left: 0px; width: 100%; height: 100%; display: block; opacity: 0.7; z-index: 10001; background-color: black;"><div style="color: #fff; font-size: 17px; font-weight: bolder;position:absolute; width: 160px;margin-left: -80px; margin-top: -30px; top: 50%; text-align: center;left:50%;">Payment in progress<br><img style="margin-top:10px" src="data:image/gif;base64,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"/></div></div>';


$(document).ready(function() {
    'use strict';

    function checkInvoiceType() {
        const type = $('#type-invoice').val();

        $('#fiscal_code-div, #cfpiva-div, #pec-div, #sdi-div')
            .hide(0)
            .find('input').prop('disabled', true);

        if (type == 'privato') {
            $('#fiscal_code-div')
                .show(0)
                .find('input').prop('disabled', false);
            $('#cfpiva-div')
                .hide(0)
                .find('input').prop('disabled', true);
            $('#pec-div, #sdi-div')
                .hide(0)
                .find('input').prop('disabled', true);
        }
        else if (type == 'azienda') {
            $('#fiscal_code-div')
                .hide(0)
                .find('input').prop('disabled', true);
            $('#cfpiva-div, #pec-div, #sdi-div')
                .show(0)
                .find('input').prop('disabled', false);
        }
    }

    $('#type-invoice').on('change', checkInvoiceType);
    checkInvoiceType();

    $('#billing-address-form #country, #type-invoice').on('change', function() {
        const invoiceType = $('#type-invoice').val();
        const countryId = $('#country').val();

        if (invoiceType == 'azienda') {
            if (countryId != 108 /* Italia */) {
                $('#pec-div, #sdi-div').addClass('hide');
                $('#pec, #sdi').prop('disabled', true);
            }
            else {
                $('#pec-div, #sdi-div').removeClass('hide');
                $('#pec, #sdi').prop('disabled', false);
            }
        }
    });

    $('#clausola').on( "click", function() {
        $('#clausola1')[0].checked = $('#clausola')[0].checked
     });

    $('[name="fattura-richiesta"]').on('change', function() {
        if (this.checked) {
            const form = this.closest('form');
            form.dataset.nextstep = this.dataset.nextstep ?? form.dataset.nextstep;
        }
    });

    $('#dispatch-address-form, #billing-address-form').validate({
        rules: {
            addressee: {
                required: true,
                minlength: 3
            }
        },
        messages: {
            addressee: {
                minlength: msg['ERR_MIN_LENGTH'].replace(':field', '').replace(':length', 3).replace('  ', ' '),
            }
        },
        errorPlacement: function(error, element) {
            const type = $(element).attr('type');
            if (type != 'checkbox' && type != 'radio') {
                $(error).insertAfter(element);
            }
            else if (type == 'radio') {
                $(error).insertAfter(element.closest('.radio'));
            }
        },
        submitHandler: submitAddressForm,
        invalidHandler: function() {
            if ($('[name="addressee"]').is('.error')) {
                const name = $('[name="addressee"]').parent().find('label').not('.error').text().replace(' *', '').toUpperCase();
                showMessageBox('danger', msg['ERR_MIN_LENGTH'].replace(':field', name).replace(':length', 3));
            }
            else {
                showMessageBox('danger', msg['ERR_MISSINGFIELDS']);
            }
        }
    });

    function submitAddressForm(form) {
        const $form = $(form);
        const country = $('#country');
        const pec = $('#pec');
        const sdi = $('#sdi');

        if (country.val() == 108 /* Italia */ && pec.is(':visible') && sdi.is(':visible') && !(pec.val() || sdi.val())) {
            showMessageBox('danger', msg['ERR_PEC_OR_SDI_REQUIRED']);
        }
        else {
            const isDispatchForm = $form.is('#dispatch-address-form');
            const emptyFields = $form.find('input[name]:disabled').toArray()
                .map(input => `${$(input).attr('name')}=`)
                .join('&');
    
            $.ajax({
                method: $form.attr('method'),
                url: $form.attr('action'),
                data: $form.serialize() + '&' + emptyFields,
                dataType: 'json',
                success: function(data) {
                    if (data.success) {
                        const redirect = function() {
                            if (isDispatchForm && window.dataLayer) {
                                dataLayer.push({ ecommerce: null });
                                pushGTMEventWithCallback(500, {
                                    event: 'add_shipping_info',
                                    ecommerce: window.ecommerce,
                                    eventCallback: GTMCallback(function() {
                                        window.location.href = $form.data('nextstep');
                                    })
                                });
                            }
                            else {
                                window.location.href = $form.data('nextstep');
                            }
                        }
    
                        if (isDispatchForm) {
                            const needInvoice = $('[name="fattura-richiesta"]:checked');
                            if (needInvoice.length > 0) {
                                $.ajax({
                                    url: "/restful/shopping/public/checkout/setproperty",
                                    method: "POST",
                                    data: {
                                        key : needInvoice.attr('name'),
                                        value: needInvoice.val()
                                    },
                                    complete: function() {
                                        if (needInvoice.val() == 'no') {
                                            $.ajax({
                                                url: "/restful/shopping/public/checkout/setproperty",
                                                method: "POST",
                                                data: {
                                                    key : 'type-invoice',
                                                    value: 'ricevuta'
                                                },
                                                complete: redirect
                                            });
                                        }
                                        else {
                                            redirect();
                                        }
                                    }
                                });
                            }
                            else {
                                redirect();
                            }
                        }
                        else {
                            const invoiceType = $('#type-invoice');
                            if (invoiceType.length > 0) {
                                $.ajax({
                                    url: "/restful/shopping/public/checkout/setproperty",
                                    method: "POST",
                                    data: {
                                        key : invoiceType.attr('name'),
                                        value: invoiceType.val()
                                    },
                                    complete: redirect
                                });
                            }
                            else {
                                redirect();
                            }
                        }
                    }
                    else {
                        showMessageBox('danger', msg[data.errors.message] || data.errors.message);
                    }
                },
                error: function() {
                    showMessageBox('danger', msg['MSG_GENERIC_ERROR']);
                }
            });
        }
    }

    $('#copy-dispatch').on('click', function() {
        $('#addressee').val(
            $('#addressee_disp').val()
        );
        $('#cap').val(
            $('#cap_disp').val()
        );
        $('#city').val(
            $('#city_disp').val()
        );
        $('#number').val(
            $('#number_disp').val()
        );
        $('#prov').val(
            $('#prov_disp').val()
        );
        $('#street').val(
            $('#street_disp').val()
        );
        $('#country').val(
            $('#country_disp').val()
        );
    });

    $('[name*="country"]').on('change', updateProvinces);
    updateProvinces();
    
    function updateProvinces() {
        $('[name*="prov"]').each(function() {
            const $this = $(this);
            const country = $this.closest('form').find('[name*="country"]');
    
            if (country.length > 0) {
                loadProvinces(country.val()).then(function(provinces) {
                    if (provinces.length > 0) {
                        const id = $this.attr('id');
                        const name = $this.attr('name');
                        const type = $this.attr('type');
                        const value = $this.val();
                        const placeholder = $this.attr('placeholder');
                        let options = [];
                        let hasSelectedValue = false;
    
                        for (let i = 0; i < provinces.length; i++) {
                            const province = provinces[i];
                            const selected = (province.code == value) ? 'selected' : '';
                            options.push(`<option value="${province.code}" ${selected}>${province.name} (${province.code})</option>`);
                            hasSelectedValue = hasSelectedValue || (province.code == value);
                        }
                        if (!hasSelectedValue) {
                            options[0].replace('  ', ' selected');
                        }
                        $this.replaceWith(`
                            <select id="${id}" name="${name}" data-type="${type}" data-placeholder="${placeholder}" data-value="${value}" required aria-required="true">
                                ${options.join('\n')}
                            </select>
                        `);
                    }
                    else if ($this.is('select')) {
                        const id = $this.attr('id');
                        const name = $this.attr('name');
                        const type = $this.data('type');
                        const value = $this.data('value');
                        const placeholder = $this.data('placeholder');
                        $this.replaceWith(`<input id="${id}" type="${type}" name="${name}" value="${value}" placeholder="${placeholder}" required aria-required="true"/>`);
                    }
                });
            }
        });
    }

    $('input[name*="sdi"]').on('input', function() {
        const value = $(this).val().replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
        $(this).val(value);
    });

    $('#booking-btn').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        
        showQuestionBox(msg["MSG_CONFIRM_BOOKING"], null, "payWithBooking()");
    });

    $('#cod-btn').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();

        showQuestionBox(msg["MSG_CONFIRM_COD"], null, "payWithCOD()");
    });
});

function vatReliefFormSubmit() {
    $('#vat-relief-form [type="submit"]').prop('disabled', false);
}

function vatReliefFormExpired() {
    $('#vat-relief-form [type="submit"]').prop('disabled', true);
    grecaptcha.reset();
}

function payWithBooking() {
    const form = document.getElementById("booking-btn").closest("form");
    
    if (window.dataLayer) {
        event.preventDefault();
        event.stopPropagation();
        dataLayer.push({ ecommerce: null });
        pushGTMEventWithCallback(500, {
            event: "add_payment_info",
            ecommerce: window.ecommerce("Booking"),
            eventCallback: GTMCallback(function() {
                if (form.requestSubmit) {
                    form.requestSubmit();
                }
                else {
                    form.submit();
                }
            })
        });
    }
    else {
        form.submit();
    }
}

function payWithCOD() {
    const form = document.getElementById("cod-btn").closest("form");

    if (window.dataLayer) {
        event.preventDefault();
        event.stopPropagation();
        dataLayer.push({ ecommerce: null });
        pushGTMEventWithCallback(500, {
            event: "add_payment_info",
            ecommerce: window.ecommerce("COD"),
            eventCallback: GTMCallback(function() {
                if (form.requestSubmit) {
                    form.requestSubmit();
                }
                else {
                    form.submit();
                }
            })
        });
    }
    else {
        form.submit();
    }
}